import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin({
  name: "ckweb:dev-console",
  dependsOn: ["ckweb:common", "ckweb:sentry"],
  setup: (nuxtApp) => {
    const publicConfig = nuxtApp.$config.public as any;
    // Disable devConsole in test and prod environments
    const devConsoleDisabled =
      $ck.utils.parseBoolean(import.meta.env.TEST) ||
      $ck.utils.parseBoolean(publicConfig?.PROD);

    const sentryEnabled =
      !devConsoleDisabled &&
      $ck.utils.parseBoolean(publicConfig?.SENTRY_ENABLED);

    const sentryCallback = (key: keyof Console, args: unknown[]) => {
      if (key !== "warn" && key !== "error") return;

      // Reuse ckbase sentry plugin injection so we don't split sentry into multiple async chunks.
      const logger = (nuxtApp as any).$sentryLogger;
      if (!logger?.fmt || typeof logger[key] !== "function") return;

      logger[key](logger.fmt`devConsole.${key}(${args})`, {
        args,
      });
    };

    const callback = sentryEnabled
      ? sentryCallback
      : devConsoleDisabled
        ? $ck.utils.DO_NOTHING
        : undefined;

    const devConsole = $ck.utils.makeDevConsole(callback);

    (globalThis as any).devConsole = devConsole;
    if (import.meta.client) {
      Object.defineProperty(window, "devConsole", { value: devConsole });
    }
  },
});
